import { render, staticRenderFns } from "./ReportsSearch.vue?vue&type=template&id=b970a638&scoped=true"
import script from "./ReportsSearch.vue?vue&type=script&lang=js"
export * from "./ReportsSearch.vue?vue&type=script&lang=js"
import style0 from "./ReportsSearch.vue?vue&type=style&index=0&id=b970a638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b970a638",
  null
  
)

export default component.exports